export const scaleYourAiSolutionMeetup = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Scale Your AI Solution Faster with Rapid Prototyping',
  startDate: '2019-10-06',
  duration: '1h',
  location: {
    '@type': 'Place',
    name: 'Merantix AI campus Berlin',
  },
  description:
    'Learn how to grow your AI startup quickly using rapid prototyping in a talk by product expert Oskar Kwitek. In this session, Oskar Kwitek will guide you through the essentials of rapid prototyping and its role in scaling AI solutions.',
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  performer: {
    '@type': 'Person',
    name: 'Oskar Kwitek',
    jobTitle: 'Product Strategist at Boldare',
  },
  url: 'https://www.boldare.com/scale-your-ai-solution-meetup/',
};
